import AuthService from '@/services/auth.service'

const state = {
  user: null,
  token: null,
  refreshToken: null,
  loading: false
}

const getters = {
  isAuthenticated: (state) => !!state.token,
  getToken: (state) => state.token,
  getRefreshToken: (state) => state.refreshToken,
  getUser: (state) => state.user
}

const actions = {
  initAuth({ commit }) {
    const token = localStorage.getItem('token')
    const refreshToken = localStorage.getItem('refreshToken')
    const user = localStorage.getItem('user')

    if (token && user) {
      commit('SET_AUTH', {
        user: JSON.parse(user),
        token,
        refreshToken
      })
    }
  },

  async login({ commit, dispatch }, credentials) {
    try {
      commit('SET_LOADING', true)
      const response = await AuthService.login(credentials)

      const user = response.payload.responseData.user
      const token = response.payload.responseData.token
      const refreshToken = response.payload.responseData.refreshToken

      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('token', token)
      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken)
      }

      commit('SET_AUTH', { user, token, refreshToken })

      dispatch(
        'notification/showSuccess',
        response.payload.message,
        { root: true }
      )
      return user
    } catch (error) {
      console.log('Login error:', error)
      const message =
        error ||
        'Login failed. Please try again.'

      dispatch(
        'notification/showError',
        message,
        { root: true }
      )

      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async SignUp({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await AuthService.SignUp(payload)

      const user = response.payload.responseData.user

      dispatch(
        'notification/showSuccess',
        response.payload.message,
        { root: true }
      )
      return user
    } catch (error) {
      console.log('SignUp error:', error)
      const message =
        error ||
        'Sign Up failed. Please try again.'

      dispatch(
        'notification/showError',
        message,
        { root: true }
      )

      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async register({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await AuthService.register(payload)

      const user = response.payload.responseData?.user

      dispatch(
        'notification/showSuccess',
        response.payload.message,
        { root: true }
      )
      return user
    } catch (error) {
      console.log('Register error:', error)
      const message =
        error ||
        'Registration failed. Please try again.'

      dispatch(
        'notification/showError',
        message,
        { root: true }
      )

      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async refresh({ commit, state }) {
    const refreshToken = state.refreshToken || localStorage.getItem('refreshToken')

    if (!refreshToken) {
      throw new Error('No refresh token available')
    }

    try {
      const response = await AuthService.refresh(refreshToken)

      const newToken = response.payload.responseData?.token || response.payload.token
      const newRefreshToken = response.payload.responseData?.refreshToken || response.payload.refreshToken

      localStorage.setItem('token', newToken)
      if (newRefreshToken) {
        localStorage.setItem('refreshToken', newRefreshToken)
      }

      commit('SET_TOKEN', newToken)
      if (newRefreshToken) {
        commit('SET_REFRESH_TOKEN', newRefreshToken)
      }

      return newToken
    } catch (error) {
      console.log('Token refresh failed:', error)
      throw error
    }
  },

  async logout({ commit, dispatch, state }) {
    const refreshToken = state.refreshToken || localStorage.getItem('refreshToken')

    try {
      if (refreshToken) {
        await AuthService.logout(refreshToken)
      }
    } catch (error) {
      console.log('Logout API error:', error)
    } finally {
      localStorage.removeItem('token')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('user')

      commit('CLEAR_AUTH')

      dispatch(
        'notification/showSuccess',
        'Logged out successfully',
        { root: true }
      )

      window.location.href = '/'
    }
  }
}

const mutations = {
  SET_AUTH(state, data) {
    state.user = data.user
    state.token = data.token
    state.refreshToken = data.refreshToken || null
  },
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  CLEAR_AUTH(state) {
    state.user = null
    state.token = null
    state.refreshToken = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
